<div class="dropzone" [ngClass]="{ drag, primary }">
  <!-- HACK: empty title to hide webkit tooltip -->
  <input
    #fileInput
    type="file"
    title=""
    [accept]="extensions.concat(mimeTypes).join(',')"
    [multiple]="multiple"
    (dragover)="drag = true"
    (dragenter)="drag = true"
    (dragleave)="drag = false"
    (dragend)="drag = false"
    (drop)="drag = false; onFileDrop($event)"
    (change)="onFileSelected($event)"
  />
  <ng-container *ngIf="!customContentTmp">
    <div class="content">
      <ng-container *ngIf="!customIconTmp">
        <mat-icon [ngClass]="{ primary }">attach_file</mat-icon>
      </ng-container>
      <ng-container *ngIf="customIconTmp">
        <ng-container *ngTemplateOutlet="customIconTmp"></ng-container>
      </ng-container>
      <div>
        <b [class.mat-primary]="primary"> {{ 'button.dnd1' | loc }} </b>{{ 'button.dnd2' | loc }} <br />
        <span class="mat-caption">{{ extensionsHr }}</span>
        <ng-container *ngIf="customFooterTmp">
          <ng-container *ngTemplateOutlet="customFooterTmp"></ng-container>
        </ng-container>
        <mat-error *ngIf="error">{{ error | loc }}</mat-error>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="customContentTmp">
    <ng-container *ngTemplateOutlet="customContentTmp; context: { extensions: extensionsHr, error: error | loc }"></ng-container>
  </ng-container>
</div>
